import { Font, StyleSheet, Text, View } from '@react-pdf/renderer';
import { Fragment, useContext } from 'react';
import { OrderType } from '../../../interfaces/delivery-company/orders';
import { IFieldConfig } from './report';
import { emptyOrder } from '../../delivery-company-components/orders/create-order-form/create-order-form.utils';
import { OrgSettingsContext } from '../../../contexts/org-settings-context';
import { IOrderDeliveryTask, IPickupTask } from '../../../interfaces/delivery-company/tasks';
import { registerFonts } from '../../../utils/pdf-fonts';

registerFonts();

const styles = (color: string) =>
  StyleSheet.create({
    row: {
      flexDirection: 'row',
      justifyContent: "flex-start",
      alignItems: 'center',
      borderBottomWidth: 1,
      height: 'auto',
      borderColor: color,
      textAlign: 'center',
      fontFamily: 'Noto Sans Arabic',
    },
  });

interface ReportTableRowsProps<T extends OrderType | IPickupTask | IOrderDeliveryTask> {
  items: T[];
  fields_config: IFieldConfig<T>[];
  color: string;
}

export function ReportTableRows<T extends OrderType | IPickupTask | IOrderDeliveryTask>({
  items,
  fields_config,
  color,
}: ReportTableRowsProps<T>) {
  const rows = items.map((item, rowIndex) => {
    return (
      <View style={styles(color).row} key={item.id} wrap={false}>
        {fields_config.map((config, index) => (
          <Text
            key={index}
            style={{
              width: config.width_percentage,
              borderColor: color,
              height: '100%',
            }}
          >
            {config.get_values(item as T).map((value) => (
              <>
                {value} {'\n'}
              </>
            ))}
          </Text>
        ))}
      </View>
    );
  });

  rows.push(
    <View
      style={{ ...styles(color).row, backgroundColor: '#777' }}
      key={'total'}
      wrap={false}
    >
      {fields_config.map((config, index) => (
        <Text
          key={index}
          style={{
            width: config.width_percentage,
            borderColor: color,
            height: '100%',
            color: 'white',
          }}
        >
          {config.get_aggregate &&
            config.get_aggregate(items).map((value) => (
              <>
                {value} {'\n'}
              </>
            ))}
        </Text>
      ))}
    </View>
  );

  return <Fragment>{rows}</Fragment>;
}